import React, { useEffect, useState } from 'react';
import 'antd/dist/reset.css';
import { Menu,Affix } from 'antd';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { eventBus } from '../event-buses/event-bus';
import { navBarEvents } from '../event-buses/event-names';

const NavBar = ({categories}) => {  

    const [selectedKeys, setSelectedKeys] = useState(categories ? [categories[0].node.id] : [])
    
    useEffect(() => {
        console.log("Side bar nav bar changed");
        console.log(selectedKeys)
    }, [selectedKeys])

    useEffect(() => {
        eventBus.on(navBarEvents.narBarSelectedItemChanging, (selectedId) => {
            console.log('Nav bar new selected item id ' + selectedId);
            setSelectedKeys([selectedId])
        })
        return () => {
            eventBus.remove(navBarEvents.narBarSelectedItemChanging)
        }
    }, [])

    const handleMenuItemClick = (selectedId) => {
        scrollTo("#"+selectedId, "start");
        setSelectedKeys([selectedId]);
    }

    const menuItems = categories.map((item) => ({
        key: item.node.id,
        label: item.node.name,
    }))

    return ( 
        <Affix offsetTop={50} className="Sidebar__Wrapper">
            <div className='Sidebar'>
                <Menu 
                    className='SidebarMenu'           
                    mode="inline"
                    selectedKeys={selectedKeys}
                    items={menuItems}
                    onClick={({ key }) => handleMenuItemClick(key)}
                >
                </Menu>
            </div>
        </Affix>       
    );
  };

export default NavBar;
